import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'eventlogmenu',
  templateUrl: 'event.log.menu.component.html',
  styleUrls: ['event.log.menu.component.scss']
})
export class EventLogMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
